<script setup lang="ts">
import { formatting, useLocalization, useOrderViewContext } from "@hantera/portal-app";
import { LabelTagDefinition, TabPanel, TabPanelTabDefinition } from "@hantera/design-system";
import { computed, ref } from "vue";
import CustomerTab from "./CustomerTab.vue";
import OrdersTab from "./OrdersTab.vue";

const orderViewContext = useOrderViewContext();
const t = useLocalization('components.order.customer');

const activeTab = ref(0);

const ordersTags = computed<LabelTagDefinition[]>(() => [
  { value: formatting.number(orderViewContext.state.customer?.orders.length ?? 0), style: 'primary' },
])

const tabs: TabPanelTabDefinition[] = [
  {
    id: 'details',
    label: t('detailsTab'),
    component: CustomerTab,
  },
  {
    id: 'orders',
    label: t('ordersTab'),
    tags: ordersTags,
    component: OrdersTab,
    props: {
      mode: 'compact',
    },
  },
]

</script>

<template>
  <TabPanel v-model="activeTab" :tabs="tabs" />
</template>
